import './App.css';
import { HashRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import React, { Suspense, useEffect } from 'react';

//import Abschlussquote from './components/Abschlussquote';
//import MarkerVerteilung from './components/MarkerVerteilung_neu';
//import Donuts from './components/Donuts';
const Donuts = React.lazy(() => import('./components/Donuts'));
const Abschlussquote = React.lazy(() => import('./components/Abschlussquote'));
const MarkerVerteilung = React.lazy(() => import('./components/MarkerVerteilung_neu'));
import UppyUpload from "./components/UppyUpload";

import { FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material';


function usePostIframeHeight() {
  useEffect(() => {
    const sendHeight = () => {
      const h = document.documentElement.scrollHeight;
      console.log("⬆️ sendHeight sendet Höhe:", h);
      window.parent.postMessage({ type: 'resize', height: h }, '*');
    };

    // Immediately send
    sendHeight();

    // Observe size changes on <html>
    const ro = new ResizeObserver(sendHeight);
    ro.observe(document.documentElement);

    // Also on window resize
    window.addEventListener('resize', sendHeight);

    return () => {
      ro.disconnect();
      window.removeEventListener('resize', sendHeight);
    };
  }, []);
}



function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname.replace('/', '') || 'abschlussquote';

  return (
<Box
  sx={{
    bgcolor: '#f8f8f8',
    minHeight: '100vh',
    fontFamily: 'Inter',
    px: { xs: 1.3, sm: 2, md: 4 },
    overflowX: 'hidden' // Sicherheit!
  }}
>
      <Box sx={{ maxWidth: 1300, mx: 'auto', pt: 4, pb: 2 }}>
        {/* Dropdown oben rechts */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 0 }}>
          <FormControl size="small" sx={{ minWidth: 200 }}>
            <InputLabel>Analyse wählen</InputLabel>
            <Select
              label="Analyse wählen"
              value={path}
  onChange={e => {
    const currentParams = window.location.hash.split('?')[1] || '';
    navigate(`/${e.target.value}${currentParams ? `?${currentParams}` : ''}`);
  }}
            >
              <MenuItem value="marker">Funnel-Analyse</MenuItem>
              <MenuItem value="abschlussquote">Abschluss-Quote</MenuItem>
              <MenuItem value ="donuts">Gruppenaufsplittungen</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Inhalt wird hier reingerendert */}
        {children}
      </Box>
    </Box>
  );
}


const allowedOrigins = [
  "https://recruitingassistent.softr.app",
  "https://www.recruitingassistent.softr.app",
  "https://sellermind.de",
  "https://www.sellermind.de",
  "https://analytics.sellermind.de"
];

// Prüfe den Referrer
const referrer = document.referrer;
const isUploadRoute = window.location.hash.includes("upload");
const isDirectAllowedHost = window.location.hostname === "analytics.sellermind.de";
const isAllowed =
  isDirectAllowedHost ||
  (referrer && allowedOrigins.some(origin => referrer.startsWith(origin)));



if (!isAllowed && !isUploadRoute) {
  document.body.innerHTML = `
    <div style="padding: 4rem; font-family: sans-serif; text-align: center; font-size: 1.2rem">
      ❌ Kein Zugriff: Unerlaubte Einbettung.
    </div>
  `;
  throw new Error("Nicht erlaubter Referrer: " + referrer);
}


export default function App() {
  usePostIframeHeight();
  return (
    <HashRouter>
      <Routes>
<Route path="upload" element={<UppyUpload />} />
<Route
  path="marker"
  element={
    <Layout>

<Suspense
  fallback={
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '40vh',     
        fontSize: 22,
        fontWeight: 500,
        color: '#506F56',      
        letterSpacing: 1.5,
        width: '100%',
      }}
    >
      🔄 Lädt Daten…
    </div>
  }
>
  <MarkerVerteilung />
</Suspense>

    </Layout>
  }
/>
<Route
  path="abschlussquote"
  element={
    <Layout>
<Suspense
  fallback={
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '40vh',      
        fontSize: 22,
        fontWeight: 500,
        color: '#506F56',       
        letterSpacing: 1.5,
        width: '100%',
      }}
    >
      🔄 Lädt Daten…
    </div>
  }
>
  <Abschlussquote />
</Suspense>

    </Layout>
  }
/>
        <Route
          path="*"
          element={
            <Layout>
              <Abschlussquote />
            </Layout>
          }
        />
<Route
  path="donuts"
  element={
    <Layout>
<Suspense
  fallback={
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '40vh',      
        fontSize: 22,
        fontWeight: 500,
        color: '#506F56',       
        letterSpacing: 1.5,
        width: '100%',
      }}
    >
      🔄 Lädt Daten…
    </div>
  }
>
  <Donuts />
</Suspense>
    </Layout>
  }
/>
      </Routes>
    </HashRouter>
  );
}
